import { gql } from '@zenbusiness/application-commons-graphql';

export const GET_BANK_ACCOUNT = gql`
  query bankAccount($input: BankAccountInput!) {
    bankAccount(input: $input) {
      accountNumber
      availableBalance {
        amount
        currency
        formattedAmount
      }
      id
      name
      routingNumber
    }
  }
`;
